import { Button, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';
import CrossIcon from '../../assets/CrossIcon.svg'
import './Error.scss';

interface Props {
    rtl: boolean;
    second?: number;
    errorHeading: string;
    errorSubHeading?: string;
    handleErrorBtnClick?: () => void;
    handleSendAgain?: () => void;
}

function Error({ rtl, second, errorHeading, errorSubHeading, handleErrorBtnClick, handleSendAgain }: Props) {
    const { t } = useTranslation();
    return (
        <div className='EL_errorBackdrop'>
            <div className={rtl ? 'EL_errorContainer EL_right' : 'EL_errorContainer'}>
                <img onClick={handleErrorBtnClick} src={CrossIcon} alt="X" />
                <div className='error__messages'>
                    <Typography className="error-heading" rtl={rtl} >{errorHeading}</Typography>
                    <Typography className="error-subheading" rtl={rtl} >{errorSubHeading}</Typography>
                    {second === 0 && (
                        <Typography rtl={rtl} className="didnt_recieve">
                            {t("Didnt_recieve_code")}
                            <span onClick={handleSendAgain}>{t("Send_again")}</span>
                        </Typography>
                    )}
                    <Button className='error-btn' onClick={handleErrorBtnClick}>{t('Got_It')}</Button>
                </div>
            </div>
        </div >
    )
}

export default Error